module.exports = __webpack_public_path__ + "static/media/review-salary-worker-third.1f172f04.jpg";